export default "__VITE_ASSET__B09uQ4rD__"